import apiClient from '../apiClient';
import { GET_RESTAURANT_RATING_URL } from '../apiUrl';

const getRestaurantRatingApi = () => {
  return apiClient.get(GET_RESTAURANT_RATING_URL);
};

export default getRestaurantRatingApi;
